module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9GfVRM/tc-custom/9781609454869.jpg?1728851578938",
      "alt": "This image is the cover for the book Strike Your Heart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Strike Your Heart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This coming of age novel by the acclaimed Belgian author is “a disarmingly simple yet deeply complex study of a mother-daughter relationship” ("), _c('i', [_vm._v("The Washington Post")]), _vm._v(").")]), _c('br'), _c('br'), _c('b', [_vm._v("One of the"), _c('i', [_vm._v(" Washington Post")]), _vm._v("’s 50 Notable Works of fiction in 2018")]), _c('br'), _c('br'), _vm._v("Marie is the prettiest girl in her provincial high school, and dating the most popular boy in town. She is the envy of all her peers—and she loves it. But when she gives birth to Diane, things begin to change. Diane steals the hearts of all who meet her, inciting nothing but jealousy in her mother."), _c('br'), _c('br'), _vm._v("This is Diane’s story. Young and brilliant, she grows up learning about life through her relationships with other women: her best friend, the sweet Élisabeth; her mentor, the selfish Olivia; her sister, the beloved Célia; and, of course, her mother. It is a story about the baser sentiments that often animate human relations: rivalry, jealousy, distrust."), _c('br'), _c('br'), _vm._v("Revered throughout Europe, Belgian novelist Amélie Nothomb has won numerous prizes, including the French Academy’s Grand Prix. In "), _c('i', [_vm._v("Strike Your Heart")]), _vm._v(", she offers a telling adult fable about womanhood and the mother-daughter bond.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amélie Nothomb, Alison Anderson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0